module.exports = __webpack_public_path__ + "static/andrea-7596c991f5b9b0d92bfb05fad9f52a1b.png";